import { RouteConfig } from 'vue-router'
import Layout from '@/layout/index.vue'

// 数据中心一级
const datasRouter: RouteConfig = {
  path: '/datas',
  component: Layout,
  redirect: '/datas/datas-distribution',
  meta: {
    title: '数据概述',
    icon: 'menu-data'
  },
  children: [
    // {
    //   name: 'DatasRealtime',
    //   path: 'datas-realtime',
    //   component: () => import('@/views/datas/datas-realtime/index.vue'),
    //   meta: {
    //     title: '实时数据'
    //   }
    // },
    {
      name: 'DatasDistribution',
      path: 'datas-distribution',
      component: () => import('@/views/datas/datas-distribution/index.vue'),
      meta: {
        title: '应用统计'
      },
      redirect: '/datas/datas-distribution/ios',
      children: [
        {
          name: 'DatasDistributionIos',
          path: 'ios',
          component: () => import('@/views/datas/datas-distribution/ios.vue'),
          meta: {
            title: 'iOS'
          }
        },
        {
          name: 'DatasDistributionAndroid',
          path: 'android',
          component: () => import('@/views/datas/datas-distribution/android.vue'),
          meta: {
            title: 'Android'
          }
        }
      ]
    },
    {
      name: 'DatasContent',
      path: 'datas-content',
      component: () => import('@/views/datas/datas-content/index.vue'),
      meta: {
        title: '内容统计'
      },
      redirect: '/datas/datas-content/content',
      children: [
        {
          name: 'DatasContentPage',
          path: 'content',
          component: () => import('@/views/datas/datas-content/content.vue'),
          meta: {
            title: '内容统计'
          }
        }
      ]
    }
    // {
    //   name: 'DatasCooperation',
    //   path: 'datas-cooperation',
    //   component: () => import('@/views/datas/datas-cooperation/index.vue'),
    //   meta: {
    //     title: '联运游戏数据'
    //   }
    // }
  ]
}

export default datasRouter
